// Accept number or placeholder
export const numberOrPlaceholder = "(\\d+(\\.\\d+)?)|(\\$\\{.*\\})"
export const integerOrPlaceholder = "(\\d+)|(\\$\\{.*\\})"
